<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="isCreate ? 'Thêm nhóm mới' : 'Sửa nhóm'"
    :visible="visible"
    :show-close="!callingAPI"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="key"
label="Mã nhóm">
            <el-input
              v-model="form.key"
              :disabled="!isCreate"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="name"
label="Tên nhóm">
            <el-input
v-model="form.name"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="order"
label="STT nhóm">
            <el-input-number
              v-model="form.order"
              class="w-100"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="fields"
:label="`Trường dữ liệu (${form.fields.length})`">
            <el-select
              v-model="form.fields"
              placeholder="Chọn thông tin"
              multiple
              cleable
              filterable
              class="w-100"
            >
              <el-option
                v-for="field in filteredFields"
                :key="field.key"
                :label="field.name"
                :value="field.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import PATTERNS from "@/config/patterns.js";
import constants from "@/config/constants.js";
import { notification } from "@/utils/common";

export default {
  name: "GroupFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    groups: Array,
    fields: Array
  },
  data() {
    return {
      form: {
        key: this.item ? this.item.key : "",
        name: this.item ? this.item.name : "",
        order: this.item ? this.item.order : 0,
        fields: this.item ? this.item.fields || [] : [],
      },
      callingAPI: false,
    };
  },
  computed: {
    allGroupKeys() {
      return (this.groups || [])
        .filter((c) => c.key !== this.item?.key)
        .map((c) => c.key);
    },
    rules() {
      const validateKey = (rule, value, callback) => {
        if (value && this.allGroupKeys.includes(value.trim())) {
          callback(new Error("Mã nhóm đã tồn tại"));
        } else {
          callback();
        }
      };
      return {
        key: [
          {
            required: true,
            message: "Mã nhóm không được để trống",
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.KEY,
            message: "Mã nhóm không hợp lệ",
            trigger: ["blur", "change"],
          },
          {
            validator: validateKey,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "Tên nhóm không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    isCreate() {
      return !this.item || !this.item.key;
    },
    otherGroupFieldKeys() {
      return this.groups.filter((g) => g !== this.item.key).map((g) => g.fields || []).flat();
    },
    filteredFields() {
      return this.fields.filter((f) => ![
        constants.FIELD_TYPE.MODULE,
        constants.FIELD_TYPE.AVATAR,
        constants.FIELD_TYPE.FILE_IMAGES,
        constants.FIELD_TYPE.FILE_VIDEOS,
        constants.FIELD_TYPE.FILE_AUDIOS,
        constants.FIELD_TYPE.FILE_OTHERS,
        constants.FIELD_TYPE.LINK_3DS,
        constants.FIELD_TYPE.LINK_YOUTUBE,
      ].includes(f.type));
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let groups = [];
          if (this.isCreate) {
            groups = [this.form, ...this.groups];
          } else {
            groups = this.groups.map((g) => {
              if (g.key === this.item.key) {
                return this.form;
              }
              return g;
            });
          }
          this.$emit("save", {
            payload: { groups },
            success: () => {
              notification(
                this,
                "success",
                this.isCreate ? "create" : "update",
                `nhóm hiển thị`
              );
              this.$emit("close");
            },
            error: () => {
              notification(
                this,
                "error",
                this.isCreate ? "create" : "update",
                `nhóm hiển thị`
              );
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
